import { SearchResult } from './search-results';

export function mergeSearchResults(
  maxResults: number,
  licenseSearchResults: SearchResult[],
  propertySearchResults: SearchResult[]
) {
  // Property and license searches can return results pointing to the same property. For the sake of better UX, I
  // want to deduplicate them. License search takes precedence, as it has more specific data (e.g. when user searches
  // for a license number, I want to show them over the fuzzy-matches property entry with the latest license number).

  const matchedDeckardIds = new Set(
    licenseSearchResults.map((result) => result.deckardid)
  );
  const filteredPropertyResults = propertySearchResults.filter(
    (result) => !matchedDeckardIds.has(result.deckardid)
  );

  return [
    // License search results go first, as they typically more relevant than property results.
    ...licenseSearchResults,
    ...filteredPropertyResults,
  ].slice(0, maxResults);
}
